import { render, staticRenderFns } from "./quesGuide21.vue?vue&type=template&id=3d47827b"
import script from "./quesGuide21.vue?vue&type=script&lang=js"
export * from "./quesGuide21.vue?vue&type=script&lang=js"
import style0 from "./quesGuide21.vue?vue&type=style&index=0&id=3d47827b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports